import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-arrow-down",
  "use": "tc-svg-arrow-down-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol viewBox=\"0 0 13 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-arrow-down\">\n<path d=\"M0.5 1L6.5 7L12.5 1\" stroke=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol